import Lottie from 'lottie-react';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';
import { EventResponse } from '../types';
import { AppointmentData, Business } from '../../../features/availability/types/index';
import DateIcon from '@/assets/img/day-icon.png';
import TimeIcon from '@/assets/img/time-icon.png';
import CheckInIcon from '@/assets/img/check-in-icon.svg';
import CheckOutIcon from '@/assets/img/check-out-icon.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import appCompoLoading from '@/assets/animation/loading.json';
import './cancel.scss';
import 'react-calendar/dist/Calendar.css';
import { useDeleteService } from '../api/deleteAppointment';
import { useAppointment } from '../api/getAppointmentDetails';
import Website from '@/assets/img/v2/website.svg';
import Utils from '@/utils/util';

import '../../../features/availability/components/AppointmentConfirmation.scss';
import ConfirmationDialogV2 from '@/components/ConfirmationDialog/ConfirmationDialogV2';

export type AppointmentConfirmationProps = {
  appointmentData?: AppointmentData;
};
export const CancelAppointment = () => {
  const { slug } = useParams();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');
  const deleteDiscussionMutation = useDeleteService();
  const [businessData, setBusinessData] = useState<Business>();
  const [eventData, setEventData] = useState<EventResponse>();
  const navigate = useNavigate();
  const [refundDetails, setRefundDetails] = useState<any>();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);

  const appointmentQuery = useAppointment({
    slugName: slug,
    token: token ? token : '',
    isRoomBooking: window.location.pathname.indexOf('booking') >= 0 ? true : false,
  });
  
  useEffect(() => {
    setEventData(appointmentQuery.data);
    if(appointmentQuery.data) {
      setRefundDetails({ refundAmount: appointmentQuery.data.refundAmount });
      setBusinessData(appointmentQuery.data.businessLocation);
    } 
  }, [appointmentQuery.data]);

  if (appointmentQuery.isLoading) {
    return (
      <div className="h-full w-full flex items-center justify-center loader-animation-user">
        <Lottie className="h-60 w-60" animationData={appCompoLoading} />
      </div>
    );
  }
  const isRoomBooking = eventData && eventData.room ? true : false;

  const onConfirmDeleteDoc = async () => {
    if (token) {
      const res:any = await deleteDiscussionMutation.mutateAsync({
        data: {
          token: token,
          tz: moment.tz.guess(true),
          isRoomBooking: isRoomBooking,
          slugName: slug ? slug : '',
        },
      });
      const splitArray = res.redirectUrl.split('/');
      navigate(`/${splitArray[splitArray.length - 1]}`);
    }
  };
  return (
    <div className="main-layout">
      <div className="appointment-confirmation">
        <div className="cancel-apt-div">
          <div className="top">
            <h5>
              Cancel this <span>{isRoomBooking ? 'booking' : 'appointment'}</span>
            </h5>
            <p>
              {isRoomBooking
                ? 'Your booking was scheduled on following date and time'
                : 'Your appointment was scheduled on following date and time'}
            </p>
          </div>
          <div className="p-c-profile-outer bg-outer">
            <div className="p-c-profile-row">
              {eventData?.businessUser?.avatarUrl && (
                <div>
                  <span>
                    <>
                      <div className="p-c-profile-pic-block">
                        <img
                          src={eventData?.businessUser?.avatarUrl}
                          className="p-c-profile cancel-apt-img"
                        />
                      </div>
                    </>
                  </span>
                </div>
              )}
              <div className="p-c-profile-info-block">
                <div className="link-outer">
                  <div className="p-c-profile-name mr-bt-10">{businessData?.name}</div>
                  {businessData?.website && (
                    <div className="link-url">
                      <img src={Website} className="website-icon" />
                      <span>{businessData?.website}</span>
                    </div>
                  )}
                </div>
                <div className="p-c-profile-detail">
                  <div className="p-c-profile-gray mr-bt-10">{businessData?.address}</div>
                  <div className="p-c-profile-gray"> {businessData?.phone}</div>
                </div>
              </div>
            </div>
          </div>
          {eventData && eventData.room && eventData.accomodationType != 'daycare' ? (
            <div className="time-container set-max-width">
              <div className="schedule-demo-date">
                <p>
                  <img src={CheckInIcon} />

                  <span>
                    {Utils.getOnlyDate(
                      eventData?.startTime,
                      businessData?.timezone,
                      "DD MMM 'yy, hh:mma"
                    )}{' '}
                  </span>
                </p>
                <p>Check-in time</p>
              </div>
              <div className="schedule-demo-time">
                <p>
                  <img src={CheckOutIcon} />
                  <span>
                    {Utils.getOnlyDate(
                      eventData?.endTime,
                      businessData?.timezone,
                      "DD MMM 'yy, hh:mma"
                    )}{' '}
                  </span>
                </p>
                <p>Check-out time</p>
              </div>
            </div>
          ) : (
            <div className="time-container set-max-width">
              <div className="schedule-demo-date">
                <p className="time-p">
                  <img src={DateIcon} />

                  <span>
                    {Utils.getOnlyDate(
                      eventData?.startTime,
                      businessData?.timezone,
                      'MMMM DD, YYYY'
                    )}{' '}
                  </span>
                </p>
                <p>Scheduled date</p>
              </div>
              <div className="schedule-demo-time">
                <p className="time-p">
                  <img src={TimeIcon} />
                  <span>
                    {eventData?.startTime &&
                      Utils.getOnlyDate(
                        eventData?.startTime,
                        businessData?.timezone,
                        'hh:mma'
                      )}{' '}
                    -{' '}
                    {eventData?.endTime &&
                      Utils.getOnlyDate(eventData?.endTime, businessData?.timezone, 'hh:mma')}{' '}
                    <span className="text-gray-500 text-sm">
                      {Utils.getTzAbbr(businessData?.timezone)}
                    </span>
                  </span>
                </p>
                <p>Scheduled time</p>
              </div>
            </div>
          )}

          <div className="action text-align-center">
            <button
              className="petsked-button button-dark"
              onClick={() => {
                setShowDeleteConfirmation(true);
              }}
            >
              <span> {isRoomBooking ? 'Cancel Booking' : 'Cancel Appointment'}</span>
            </button>
          </div>
          <ConfirmationDialogV2
            title={isRoomBooking ? 'Cancel Booking' : 'Cancel Appointment'}
            description={
              isRoomBooking
                ? 'Are you sure you want to cancel this booking?'
                : 'Are you sure you want to cancel this appointment?'
            }
            yesButtonLabel={isRoomBooking ? 'Cancel Booking' : 'Cancel Appointment'}
            noButtonLabel="Close"
            onCancel={() => setShowDeleteConfirmation(false)}
            onConfirm={onConfirmDeleteDoc}
            open={showDeleteConfirmation}
            isRefund={true}
          >
            {
              <div className="remove-member-confirmation refund-details">
                <div className="refund-status">
                  {refundDetails?.refundAmount
                    ? `You will receive a refund of $${refundDetails?.refundAmount}, and it will take 5-10 days to appear on your statement.`
                    : 'You will not get any refund'}
                </div>
              </div>
            }
          </ConfirmationDialogV2>
        </div>
      </div>
    </div>
  );
};
